export default function getPrivacyURL() {
  return 'http://it.madai.com/index.php/norme-sulla-privacy';
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/getPrivacyURL.js
 **/